module.exports = __webpack_public_path__ + "img/cardlocation.9ab919ef.svg";